import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@/components/ui/button";
export default function Header() {
  const { isAuthenticated, isLoading, loginWithRedirect, logout, user } = useAuth0();

  if (isLoading) return null;


  return (
    <header className="bg-white pt-6 px-6 flex items-center justify-end gap-6">

      {isAuthenticated ? (
        <div className="flex items-center gap-6">
        <p>Welkom, {user?.nickname}! </p>
          <Button variant="outline" onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
              Log Uit
          </Button>
          </div>
        ) : (
        <Button variant="outline" onClick={() => loginWithRedirect()}>
          Log In
        </Button>
      )}  
    </header>
  )
}
